import { render, staticRenderFns } from "./valuation-table.vue?vue&type=template&id=7c0cb2b8"
import script from "./valuation-table.vue?vue&type=script&lang=js"
export * from "./valuation-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports